module.exports = __webpack_public_path__ + "static/media/Unilever-Azul.36d351b1.png";